module.exports = __webpack_public_path__ + "static/media/st-xenia.78e4fe47.jpg";